/**
 * @flow
 * @relayHash f958ab30bf334b8679357ccd840f255f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SolicitationState = "A_1" | "A_2" | "A_3" | "%future added value";
export type RevertClosedSolicitationInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type RevertClosedSolicitationMutationVariables = {|
  input: RevertClosedSolicitationInput
|};
export type RevertClosedSolicitationMutationResponse = {|
  +revertClosedSolicitation: ?{|
    +isUpdated: ?boolean,
    +solicitation: ?{|
      +id: string,
      +state: SolicitationState,
    |},
  |}
|};
export type RevertClosedSolicitationMutation = {|
  variables: RevertClosedSolicitationMutationVariables,
  response: RevertClosedSolicitationMutationResponse,
|};
*/


/*
mutation RevertClosedSolicitationMutation(
  $input: RevertClosedSolicitationInput!
) {
  revertClosedSolicitation(input: $input) {
    isUpdated
    solicitation {
      id
      state
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RevertClosedSolicitationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "revertClosedSolicitation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RevertClosedSolicitationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isUpdated",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "solicitation",
        "storageKey": null,
        "args": null,
        "concreteType": "SolicitationNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RevertClosedSolicitationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RevertClosedSolicitationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RevertClosedSolicitationMutation",
    "id": null,
    "text": "mutation RevertClosedSolicitationMutation(\n  $input: RevertClosedSolicitationInput!\n) {\n  revertClosedSolicitation(input: $input) {\n    isUpdated\n    solicitation {\n      id\n      state\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7991f40e22b954d06427bddfc61cc607';
module.exports = node;
